import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { px2rem } from '../utils/helpers/style.js';
import { lineHeights } from '../constants/line-heights.js';
import { spacing, spacingNumerical } from '../constants/spacing.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var notificationColors = {
  primary: {
    background: 'notification.primary.background',
    textColor: 'notification.primary.text'
  },
  alert: {
    background: 'notification.alert.background',
    textColor: 'notification.alert.text'
  },
  warning: {
    background: 'notification.warning.background',
    textColor: 'notification.warning.text'
  },
  info: {
    background: 'notification.info.background',
    textColor: 'notification.info.text'
  }
};
var notificationWebAttributes = {
  paddingHorizontal: spacing.xxs,
  paddingVertical: spacing.xxs,
  borderRadius: 'borders.radius',
  colors: notificationColors,
  contentText: {
    lineHeight: lineHeights.tight
  },
  heading: {
    weight: 'medium',
    marginBottom: spacing.xxxxs,
    lineHeight: lineHeights.tight
  }
};
var notificationThemeWeb = _objectSpread(_objectSpread({}, notificationWebAttributes), {}, {
  variants: {
    condensed: {
      paddingHorizontal: spacing.xxs,
      paddingVertical: px2rem(12)
    }
  }
});
var notificationNativeAttributes = {
  paddingHorizontal: 16,
  paddingTop: 16,
  paddingBottom: 16,
  colors: notificationColors,
  height: 56,
  margin: {
    vertical: 0,
    horizontal: spacingNumerical.xxs
  },
  icon: {
    marginHorizontal: 8,
    size: 24
  },
  text: {
    textSize: 16,
    gap: '4px',
    lineHeight: lineHeights.tight
  },
  heading: {
    textSize: 16,
    weight: 'medium',
    marginTop: -2,
    lineHeight: lineHeights.tight
  }
};
var notificationThemeNative = _objectSpread(_objectSpread({}, notificationNativeAttributes), {}, {
  variants: {
    condensed: {
      paddingTop: 12,
      paddingBottom: 16
    }
  }
});

export { notificationNativeAttributes, notificationThemeNative, notificationThemeWeb };
